import { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext({ lang: "fr", setLang: () => {} });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("tropikal_lang") || "fr");
  useEffect(() => { localStorage.setItem("tropikal_lang", lang); }, [lang]);
  return <LangContext.Provider value={{ lang, setLang, toggle: () => setLang((l) => (l === "fr" ? "en" : "fr")) }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
